import React from 'react';
import Typography from '../../../../shared/components/Typography/Typography';
import { getPartnerRoleLabel, getPartnerDisplayName, getPartnerLifecycle } from '../partnerModel';
import ScorePanel from '../../components/ScorePanel';

const Field = ({ label, value }) => <div className="partner-field"><dt>{label}</dt><dd>{value || '-'}</dd></div>;

function PartnerInformationPanel({ partner, marketingScore }) {
  const lifecycle = getPartnerLifecycle(partner.lifecycleStatus);
  const relationship = { prospect: 'Prospect', client: 'Client', client_inactif: 'Client inactif' }[partner.relationshipStatus] || 'Prospect';
  return (
    <section className="partner-section" role="tabpanel">
      <div className="partner-section__header"><Typography variant="h6">Vue d’ensemble du partenaire</Typography></div>
      <div className="partner-information-groups">
      <section className="partner-information-group"><h3>Relation CRM</h3><dl className="partner-field-grid">
        <Field label="Statut administratif" value={lifecycle.label} />
        <Field label="Relation" value={relationship} />
        <Field label="Source d’acquisition" value={partner.originSource} />
        <Field label="Rôles" value={(partner.roles || []).map((role) => getPartnerRoleLabel(role)).join(', ')} />
        {partner.relationshipStatus === 'prospect' && <Field label="Priorité marketing" value={partner.marketingPriority} />}
        <Field label="Dernière interaction" value={partner.lastCommercialActivityAt ? new Date(partner.lastCommercialActivityAt).toLocaleDateString('fr-FR') : '—'} />
        <Field label="Prochaine relance" value={partner.nextFollowUpAt ? new Date(partner.nextFollowUpAt).toLocaleDateString('fr-FR') : '—'} />
      </dl></section>
      <section className="partner-information-group"><h3>Identité</h3><dl className="partner-field-grid">
        <Field label="Raison sociale" value={partner.socialReason} />
        <Field label="Nom commercial" value={partner.name} />
        <Field label="Nom légal" value={partner.legalName} />
        <Field label="Nom d’affichage" value={getPartnerDisplayName(partner)} />
        <Field label="Notes" value={partner.notes} />
      </dl></section>
      <section className="partner-information-group"><h3>Coordonnées</h3><dl className="partner-field-grid">
        <Field label="Téléphone" value={partner.phone} />
        <Field label="Email" value={partner.email} />
        <Field label="Site web" value={partner.website} />
        <Field label="Pays" value={partner.countryCode === 'FR' ? 'France' : partner.countryCode} />
        <Field label="Adresse" value={partner.addressLine1 || partner.address} />
        <Field label="Complément" value={partner.addressLine2} />
        <Field label="Code postal" value={partner.postalCode} />
        <Field label="Ville" value={partner.city} />
        <Field label="Région / État" value={partner.regionOrState} />
      </dl></section>
      <section className="partner-information-group"><h3>Informations légales</h3><dl className="partner-field-grid">
        <Field label="Effectif" value={partner.employees} />
        <Field label="Capital" value={partner.capital} />
        <Field label="SIRET" value={partner.siret} />
        <Field label="SIREN" value={partner.siren} />
        <Field label="TVA" value={partner.vat} />
        <Field label="Code NAF" value={partner.nafCode} />
      </dl></section></div>
      {partner.relationshipStatus === 'prospect' && <ScorePanel title="Score marketing" score={marketingScore} />}
    </section>
  );
}

export default PartnerInformationPanel;
